import axios from 'axios';
import { ApiPath } from '@/tools/network_tools';
import NetworkManager from '@/utils/NetworkManager';

export class RequestManager {
  constructor(config) {
    this.onProgress = undefined;
    this.network = new NetworkManager(config);
  }
  setProgress(onProgress) {
    this.onProgress = onProgress;
  }
  async reqNewJob(cred, renderParams) {
    const uri = this.network.renderUri();
    const params = this.apiParams(cred, 'new', undefined, renderParams);
    return await this.post(uri, params);
  }
  async uploadJob(uri, contents) {
    return await this.put(uri, contents);
  }
  async reqJobResult(cred, jobID) {
    const uri = this.network.renderUri();
    const params = this.apiParams(cred, 'result', jobID);
    return await this.post(uri, params);
  }
  apiParams(cred, type, jobID = undefined, renderParams = undefined) {
    return {
      cred: cred,
      type: type,
      api: 'rapi',
      jobID: jobID,
      render: renderParams,
    };
  }
  async enable2FA(userId) {
    // console.log(userId);
    const params = { userId: userId };
    const uri = this.network.uriPath('2fa', ApiPath.Tfa);
    return await this.post(uri, params);
  }
  async verify2FA(userId, token) {
    const params = {
      userName: userId, token: token, type: "verify"
    };
    const uri = this.network.uriPath('api', ApiPath.Login);
    return await this.post(uri, params);
  }
  async getUserVerification(uid, userName, token) {
    const params = {
      userName: userName,
      uid: uid,
      token: token,
      "type": "profile"
    }
    const uri = this.network.uriPath('api', ApiPath.Login);
    return await this.post(uri, params);
  }
  async getUserMedia(uid, userName, token, media) {
    const params = {
      uid: uid,
      media: media,
      token: token,
      "type": "media",
      userName: userName,
    }
    const uri = this.network.uriPath('api', ApiPath.Login);
    return await this.post(uri, params);
  }
  async verifyUserProfile(uid, userName, token, verifyInfo) {
    const params = {
      uid: uid,
      token: token,
      userName: userName,
      "type": "verifyInfo",
      "verifyInfo": verifyInfo,
    }
    const uri = this.network.uriPath('api', ApiPath.Login);
    return await this.post(uri, params);
  }

  async login(data, password, isCred = false) {
    const params = { data: data };
    if (isCred) {
      params.type = "password";
      params.cred = password;
    }
    else {
      params.type = "token";
      params.token = password;
    }
    const uri = this.network.uriPath('api', ApiPath.Login);
    return await this.post(uri, params);
  }

  async setNew2FA(userName, secret) {
    const params = {
      userName: userName, secret: secret, type: "2fa"
    };
    const uri = this.network.uriPath('api', ApiPath.Login);
    return await this.post(uri, params);
  }

  async post(uri, data) {
    const info = await axios.post(uri, data);
    if (!info) return { msg: 'REQUEST_FAILED', data: undefined };
    return info.data;
  }
  async put(uri, contents) {
    const headers = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      onUploadProgress: this.onUploadProgress.bind(this),
    };
    try {
      const request = await axios.put(uri, contents, headers);
      return request.status === 200 ? 'SUCCESS' : 'FAILED';
    } catch (e) {
      return String(e);
    }
  }
  onUploadProgress(progressEvent) {
    const percentage = Math.round(
      (progressEvent.loaded * 100) / progressEvent.total
    );
    this.onProgress && this.onProgress(percentage);
  }
}

